import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminPartnersApi as r } from "@maat/api-main";
//#region src/partners/admin/useUpdatePartnerMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, data: t }) => r.update(e, t),
		onSuccess: (t, { id: n }) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useUpdatePartnerMutation };
